(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["olane-careers"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-soc-role]');
    if (!link) return;
    var root = link.closest('.olane-careers');
    if (!root) return;
    var select = root.querySelector('select[name="contact[role]"]');
    if (select) select.value = link.dataset.socRole;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olane-creator-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('olane-creator-carousel')) {
    customElements.define('olane-creator-carousel', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }
      setup() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        this.track = this.querySelector('.olane-creator-gallery__grid');
        this.controls = this.querySelector('.olane-creator-gallery__controls');
        this.previous = this.querySelector('[data-direction="previous"]');
        this.next = this.querySelector('[data-direction="next"]');
        if (!this.track || !this.controls || !this.previous || !this.next) return;
        const update = () => {
          const maximum = this.track.scrollWidth - this.track.clientWidth;
          const position = Math.abs(this.track.scrollLeft);
          this.controls.hidden = maximum <= 2;
          this.previous.disabled = position <= 2;
          this.next.disabled = position >= maximum - 2;
        };
        this.previous.addEventListener('click', () => this.move(-1), { signal: this.controller.signal });
        this.next.addEventListener('click', () => this.move(1), { signal: this.controller.signal });
        this.track.addEventListener('scroll', update, { passive: true, signal: this.controller.signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        }, { signal: this.controller.signal });
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.track);
        update();
      }
      move(direction) {
        const card = this.track.querySelector('.olane-creator-gallery__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const distance = card.getBoundingClientRect().width + gap;
        this.track.scrollBy({ left: distance * direction * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }
  if (!customElements.get('olane-creator-video')) {
    customElements.define('olane-creator-video', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        const button = this.querySelector('button');
        if (!button) return;
        button.addEventListener('click', () => {
          if (this.querySelector('iframe')) return;
          document.querySelectorAll('olane-creator-video.is-playing').forEach(other => {
            other.querySelector('iframe')?.remove();
            other.classList.remove('is-playing');
          });
          const template = this.querySelector('template');
          if (!template) return;
          this.append(template.content.cloneNode(true));
          this.classList.add('is-playing');
          this.querySelector('iframe')?.focus();
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      var fetched = container.querySelector(".related-products");
      if (fetched === null) { return; }
      productRecommendationsSection.innerHTML = fetched.innerHTML;
      productRecommendationsSection.hidden = fetched.hasAttribute("hidden");
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
